export class TableSounds {
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;

    this.soundsList = this.scene.soundsList;
    // this.find("show-win-amount").setVolume(5);
  }

  play(soundKey) {
    // if(!this.scene.gameIsHidden) {
    // this.find(soundKey).play();
    // if(!this.scene.isAudioAllowed(this.table)) {
    //     this.find(soundKey).mute = true;
    // }

    if (!this.scene.isAudioAllowed(this.table)) return;
    if (soundKey === "timer") {
      this.find(soundKey).play();
    } else if (soundKey === "show-win-amount") {
      this.scene.sound.play(soundKey, { volume: 5 });
    } else {
      this.scene.sound.play(soundKey);
    }

    // }
  }

  find(soundKey) {
    return this.soundsList.find((sound) => sound.key === soundKey);
  }

  muteAll() {
    this.soundsList.forEach((sound) => {
      sound.mute = true;
    });
  }

  /**
   * @param list { string []} => list of sounds which we don't want to mute..
   */
  muteAllExcept(list) {
    this.soundsList.forEach((sound) => {
      if (!list.find((ex) => sound.key === ex)) {
        sound.mute = true;
      }
    });
  }

  unmuteAll() {
    this.soundsList.forEach((sound) => {
      // if(sound && sound.mute) sound.mute = false;
      if (sound) sound.setMute(false);
    });
  }

  remove() {}
}
